import { ReactNode, useEffect } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';

const useFunnelFormProvider = <T,>({
  data,
  onSubmit
}: {
  data?: T;
  onSubmit?: (data: T) => void;
}) => {
  const methods = useForm<T & FieldValues>();

  useEffect(() => {
    if (!data) return;
    methods.reset({ ...data });
  }, [data]);

  const FunnelFormProvider = ({ children }: { children: ReactNode }) => {
    return (
      <FormProvider {...methods}>
        <form onSubmit={onSubmit ? methods.handleSubmit(onSubmit) : undefined}>
          {children}
        </form>
      </FormProvider>
    );
  };

  return { FunnelFormProvider, methods };
};

export default useFunnelFormProvider;
